import React from "react";
import { Star, Quote, MapPin } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  name: "Isabella Montgomery",
  location: "Chelsea, London",
  feedback: "The wet room installation exceeded every expectation. The precision of the tiling and the seamless drainage are a testament to their technical excellence. Our bathroom feels like a private spa.",
  rating: 5
}, {
  name: "Arthur Sterling",
  location: "Kensington, London",
  feedback: "A complete bathroom transformation of the highest order. From the initial design phase to the final fixture placement, the team was professional and the finish is absolute luxury.",
  rating: 5
}, {
  name: "Elena Ricci",
  location: "Richmond, Surrey",
  feedback: "We chose them for a high-end renovation and were not disappointed. The custom stonework and Bormioli fixtures are stunning. A truly premium service for those who value detail.",
  rating: 5
}, {
  name: "Julian Vane",
  location: "Mayfair, London",
  feedback: "Exceptional craftsmanship throughout. They managed the complex plumbing of our Victorian suite with ease, and the final result is a modern masterpiece that honors the home's heritage.",
  rating: 5
}];
export default function Testimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="21370" id="customer-reviews" ref={ref} className="bg-secondary text-foreground py-20 md:py-28">
      <style dangerouslySetInnerHTML={{
      __html: `
        body { text-align: left; }
        .container { margin-left: 0 !important; margin-right: auto !important; }
        .flex, .grid { justify-content: flex-start; }
      `
    }} />
      <div className="container ml-0 mr-auto px-4 md:px-6 max-w-4xl">
        <div className={`text-left mb-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="text-ring font-sans font-bold tracking-widest uppercase text-sm mb-3">
            Client Testimonials
          </h2>
          <h3 className="text-3xl md:text-5xl font-bold mb-4 font-serif text-foreground">
            The Mark of Excellence
          </h3>
          <p className="text-foreground/80 max-w-2xl ml-0 text-lg font-sans leading-relaxed">
            Discover why London's most discerning homeowners trust our specialized team for their most ambitious bathroom and wet room projects.
          </p>
        </div>

        <div className="space-y-6">
          {testimonials.map((item, i) => <div key={i} data-index={i} className={`transition-all duration-700 delay-${i * 100} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
              <Card className="border-slate-500/30 shadow-none bg-secondary/40 rounded-sm">
                <div className="flex flex-col md:flex-row md:items-start gap-4 p-6 md:p-8">
                  <div className="shrink-0">
                    <div className="size-12 rounded-sm bg-foreground/5 flex items-center justify-center text-foreground/20">
                      <Quote className="size-6 fill-current opacity-30" />
                    </div>
                  </div>
                  
                  <div className="flex-1 space-y-4">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                      <div>
                        <h4 className="font-serif font-bold text-xl text-foreground">{item.name}</h4>
                        <div className="flex items-center text-sm text-foreground/60 gap-1 font-sans">
                          <MapPin className="size-3.5" />
                          <span>{item.location}</span>
                        </div>
                      </div>
                      <div className="flex gap-0.5">
                        {[...Array(5)].map((_, starIndex) => <Star key={starIndex} className={`size-4 stroke-1 ${starIndex < item.rating ? "fill-ring text-ring" : "text-foreground/10"}`} />)}
                      </div>
                    </div>
                    
                    <p className="text-foreground/90 text-base leading-relaxed font-sans italic">
                      "{item.feedback}"
                    </p>
                  </div>
                </div>
              </Card>
            </div>)}
        </div>

        <div className={`mt-12 text-left transition-all duration-700 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Button asChild size="lg" className="rounded-sm px-10 bg-ring hover:bg-ring/90 text-primary-foreground font-sans tracking-wide">
            <Link to="#">
              Request A Consultation
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}